const LOCAL_STORAGE_KEY = 'nuxt-utm-data';

export default defineNuxtPlugin((nuxtApp) => {
	const storage = useLocalStorage();

	function processUtmData() {
		if (typeof window === 'undefined') return;

		const query = nuxtApp._route.query;

		if (query.utm_content) {
			storage.setItem(LOCAL_STORAGE_KEY, {
				utm_term: query.utm_term as string,
				utm_content: query.utm_content as string,
				utm_campaign: query.utm_campaign as string
			});
		}
	}

	function getUtmData() {
		try {
			if (typeof window === 'undefined') return {};

			const data = storage.getItem(LOCAL_STORAGE_KEY);
			const parsedData = JSON.parse(data ?? '{}');

			return {
				utm_term: parsedData?.utm_term as string,
				utm_content: parsedData?.utm_content as string,
				utm_campaign: parsedData?.utm_campaign as string
			};
		} catch (error) {
			console.error(error);
			return {};
		}
	}

	nuxtApp.hook('app:mounted', processUtmData);

	return {
		provide: { getUtmData }
	};
});
